import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import OtherOptionService from "services/OtherOptionService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllOtherOptions = createAsyncThunk(
  "other-option/getAllOtherOptions",
  async (params, { rejectWithValue }) => {
    try {
      const response = await OtherOptionService.getAllOtherOptions(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertOtherOption = createAsyncThunk(
  "other-option/upsertOtherOption",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await OtherOptionService.upsertOtherOption(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteOtherOption = createAsyncThunk(
  "other-option/deleteOtherOption",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;

      const response = await OtherOptionService.deleteOtherOption(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loadingList: false,
  loadingUpsert: false,
  loadingDelete: false,

  otherOptionList: [],
};

export const otherOptionSlice = createSlice({
  name: "other-option",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET LIST
      .addCase(getAllOtherOptions.pending, (state) => {
        state.loadingList = true;
      })
      .addCase(getAllOtherOptions.fulfilled, (state, action) => {
        state.loadingList = false;
        state.otherOptionList = action.payload;
      })
      .addCase(getAllOtherOptions.rejected, (state) => {
        state.loadingList = false;
      })

      // UPDATE
      .addCase(upsertOtherOption.pending, (state) => {
        state.loadingUpsert = true;
      })
      .addCase(upsertOtherOption.fulfilled, (state) => {
        state.loadingUpsert = false;
      })
      .addCase(upsertOtherOption.rejected, (state) => {
        state.loadingUpsert = false;
      })

      // DELETE
      .addCase(deleteOtherOption.pending, (state) => {
        state.loadingDelete = true;
      })
      .addCase(deleteOtherOption.fulfilled, (state) => {
        state.loadingDelete = false;
      })
      .addCase(deleteOtherOption.rejected, (state) => {
        state.loadingDelete = false;
      });
  },
});

export default otherOptionSlice.reducer;